<div *ngIf="!loading">
    <header-comp></header-comp>
    <router-outlet></router-outlet>
    <footer-comp></footer-comp>
</div>